export default __webpack_public_path__ + "static/media/login-background.2a29e900.png";